export default __webpack_public_path__ + "img/5cfa419904a820a1bb5ffb2b1c5cd534.svg";